
document.addEventListener("DOMContentLoaded", async function () {
  const filterMake = document.getElementById("filter-make");
  const filterModel = document.getElementById("filter-model");
  const filterYear = document.getElementById("filter-year");

  // Fetch products for a specific collection (Make)
  async function fetchProductsForMake(makeHandle) {
    const response = await fetch(`/collections/${makeHandle}/products.json`);
    const data = await response.json();
    return data.products;
  }

  // Populate Model dropdown based on selected Make
filterMake.addEventListener("change", async function () {
    const selectedMake = this.value;
    filterModel.innerHTML = `<option value="">Select Model</option>`;
    filterYear.innerHTML = `<option value="">Select Year</option>`;

    if (selectedMake) {
        const products = await fetchProductsForMake(selectedMake);
        const models = new Set();

        products.forEach((product) => {
            product.tags.forEach((tag) => {
                if (tag.startsWith("model_")) {
                    models.add(tag.replace("model_", ""));
                }
            });
        });

        // Populate models dropdown
        models.forEach((model) => {
            const option = document.createElement("option");
            option.value = model;
            option.textContent = model;
            filterModel.appendChild(option);
        });
    }
});

// Populate Year dropdown based on selected Model
filterModel.addEventListener("change", async function () {
    const selectedMake = filterMake.value;
    const selectedModel = this.value;
    filterYear.innerHTML = `<option value="">Select Year</option>`;

    if (selectedMake && selectedModel) {
        const products = await fetchProductsForMake(selectedMake);
        const years = new Set();

        products.forEach((product) => {
            if (product.tags.includes(`model_${selectedModel}`)) {
                product.tags.forEach((tag) => {
                    if (tag.startsWith("year_")) {
                        years.add(tag.replace("year_", ""));
                    }
                });
            }
        });

        // Populate years dropdown
        [...years].sort((a, b) => a - b).forEach((year) => {
            const option = document.createElement("option");
            option.value = year;
            option.textContent = year;
            filterYear.appendChild(option);
        });
    }
});

  // Filter products based on Make, Model, and Year
  document.getElementById("vehicle-filter-form").addEventListener("submit", async function (e) {
    e.preventDefault();

    const make = filterMake.value;
    const model = filterModel.value;
    const year = filterYear.value;

    if (!make) {
      alert("Please select a Make.");
      return;
    }

    // Fetch all products from the selected collection (Make)
    const products = await fetchProductsForMake(make);

    // Filter products by Model and Year tags
    const filteredProducts = products.filter((product) => {
      const tags = product.tags;
      const modelMatch = model ? tags.includes(`model_${model}`) : true;
      const yearMatch = year ? tags.includes(`year_${year}`) : true;
      return modelMatch && yearMatch;
    });

    if (filteredProducts.length > 0) {
      // Redirect to the first matching product page
      window.location.href = `/products/${filteredProducts[0].handle}`;
    } else {
      alert("No products found matching your criteria.");
    }
  });
});





